<template>
  <div class="recognition">
    <div class="custom" @click="customShow = true" v-if="!customShow">自定义框图</div>
    <div class="custom" @click="customShow = false" v-if="customShow">退出框图</div>
    <div
      class="img"
      v-if="!customShow"
      :class="(imgData.height/imgData.width)*1130 >= 1000 ? 'specail-img': ''"
    >
      <img v-if="imgData.key" :src="imgBaseUrl + imgData.key" alt id="imgload">
      <div
        class="marquee"
        :class="hoverIndex === index ? 'marquee-specail' : ''"
        v-if="getData && getData.length > 0 && (!hoverIsShow || hoverIndex === index || hoverIndex === getData.length) && item.w"
        v-for="(item, index) in getData"
        @mouseenter="menter(item, index)"
        @mouseleave="mleave"
        :key="index"
        :style="{'width': item.w + 'px', 'height': item.h + 'px', 'left': item.pw + 'px', 'top': item.ph + 'px'}"
      >
        <i class="iconfont icon-Bubble1">
          <span>{{index+1}}</span>
        </i>
        <i v-if="hoverIndex === index" class="iconfont icon-trash" @click="deleteProduct(index)"></i>
      </div>
      <div v-if="getData && getData.length > 0">
        <div class="top" v-if="bgPoint" :style="{'height' : bgPoint.topH+ 'px'}"></div>
        <div class="bottom" v-if="bgPoint" :style="{'height' : bgPoint.bottomH + 'px'}"></div>
        <div
          class="left"
          v-if="bgPoint"
          :style="{'width' : bgPoint.leftW + 'px', 'height':bgPoint.leftH + 'px', 'top':bgPoint.topH + 'px' }"
        ></div>
        <div
          class="right"
          v-if="bgPoint"
          :style="{'width' : bgPoint.rightW-((1130-actualImageW)) + 'px', 'height':bgPoint.leftH + 'px', 'top':bgPoint.topH + 'px' }"
        ></div>
      </div>
    </div>
    <div v-else>
      <custom-img
        v-if="imgData.key"
        :imgUrl="imgData.key"
        :actualImageH="actualImageH"
        :actualImageW="actualImageW"
        @surePoint="surePoint"
      ></custom-img>
    </div>
  </div>
</template>

<script>
import api from "../../../api";
import customImg from "./customImg.vue";

export default {
  data() {
    return {
      imgBaseUrl: api.common.imgBaseUrl,
      marquee: [], //选框存在的数据
      actualImageW:
        (this.imgData.height / this.imgData.width) * 1130 <= 1000
          ? 1130
          : (this.imgData.width / this.imgData.height) * 1000,
      actualImageH:
        (this.imgData.height / this.imgData.width) * 1130 <= 1000
          ? 1130 / (this.imgData.width / this.imgData.height)
          : 1000,
      bgPoint: null,
      hoverIsShow: false,
      hoverIndex: null,
      customShow: false
    };
  },
  props: {
    imgData: {
      type: Object
    }
  },
  computed: {
    getData() {
      return this.$store.state.app.identtificationData;
    }
  },
  components: { customImg },
  methods: {

    getPoint() {
      console.log(77777);
      api.imgSearch.detect_url(this.imgBaseUrl + this.imgData.key).then(res => {
        this.$nextTick(() => {
          if (res.detectedBoxes) {
            this.getMarqueeDetail(res.detectedBoxes, null);
          } else {
            this.$emit("errSearchImg");
            this.$Message.error("图片识别失败，请重新上传！");
          }
        });
      });
    },

    getMarqueeDetail(arry, type) {
      let object;
      let prw = this.actualImageW / this.imgData.width;
      let prh = this.actualImageH / this.imgData.height;
      if (!type) {
        this.marquee = [];
        arry.forEach(item => {
          let ap = this.imgData.width * item.box[0] * prw; //根据图片实际尺寸获得的left的位置
          let at = this.imgData.height * item.box[1] * prh; //根据图片实际尺寸获得的top的位置
          let aw = this.imgData.width * item.box[2] * prw; //根据图片实际尺寸获得框选的宽度
          let ah = this.imgData.height * item.box[3] * prh; //根据图片实际尺寸获得框选的高度
          object = {
            pw: ap,
            ph: at,
            w: aw,
            h: ah,
            name: item.type,
            sku: "常规",
            material: "常规",
            imgKey: this.imgData.key,
            ossPoint: {
              x: this.imgData.width * item.box[0],
              y: this.imgData.height * item.box[1],
              w: this.imgData.width * item.box[2],
              h: this.imgData.height * item.box[3]
            }
          };
          this.marquee.push(object);
        });
      } else {
        object = {
          pw: arry.px,
          ph: arry.py,
          w: arry.width,
          h: arry.height,
          name: arry.name,
          sku: "常规",
          material: "常规",
          imgKey: this.imgData.key,
          ossPoint: {
            x: arry.px / prw,
            y: arry.py / prh,
            w: arry.width / prw,
            h: arry.height / prh
          }
        };
        this.marquee.push(object);
      }
      this.$store.dispatch("getIdenttification", this.marquee);
    },
    // 图片下载
    menter(item, index) {
      if (this.getData && this.getData.length > 0) {
        this.hoverIsShow = true;
        this.hoverIndex = index;
        this.activeBg(item);
      }
    },
    mleave() {
      this.hoverIsShow = null;
      this.hoverIndex = null;
      this.bgPoint = null;
    },

    activeBg(o) {
      //鼠标hover时候背景变化
      this.bgPoint = null;
      let topH = o.ph;
      let bottomH = this.actualImageH - (o.ph + o.h);
      let leftW = o.pw;
      let rightW = 1130 - (o.pw + o.w);
      this.bgPoint = {
        topH: topH,
        bottomH: bottomH,
        leftW: leftW,
        leftH: o.h,
        rightW: rightW
      };
    },
    deleteProduct(index) {
      this.$store.dispatch("deleteIdenttification", index);
      this.bgPoint = null;
    },

    surePoint(data) {
      //获得截图的位置和尺寸
      this.customShow = false;
      if (data) {
        this.getMarqueeDetail(data, "type");
      }
    }
  },
  watch: {
    imgData: function() {
      this.actualImageW =
        (this.imgData.height / this.imgData.width) * 1130 <= 1000
          ? 1130
          : (this.imgData.width / this.imgData.height) * 1000;
      this.actualImageH =
        (this.imgData.height / this.imgData.width) * 1130 <= 1000
          ? 1130 / (this.imgData.width / this.imgData.height)
          : 1000;
        this.getPoint();
      this.customShow = false;
    }
  },
  created() {
    this.getPoint();
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped type="text/scss">
.recognition {
  display: inline-block;
  width: 100%;
  background: #f2f4f5;
  font-size: 0;
  position: relative;
  .custom {
    position: absolute;
    z-index: 800;
    right: 0;
    top: 0px;
    background: #f5a623;
    width: 140px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .img {
    width: 1130px;
    height: auto;
    display: inline-block;
    font-size: 0px;
    position: relative;
    img {
      width: 100%;
    }
    .marquee {
      position: absolute;
      border: 4px solid #f5a623;
      cursor: pointer;
      .icon-Bubble1 {
        display: inline-block;
        position: relative;
        font-size: 32px;
        top: -44px;
        color: #f5a623;
        z-index: 110;
        span {
          display: inline-block;
          width: 20px;
          text-align: center;
          position: absolute;
          top: 7px;
          font-size: 20px;
          left: 6px;
          color: #fff;
        }
      }
      .icon-trash {
        display: inline-block;
        position: absolute;
        right: 5px;
        top: 5px;
        color: #353838;
        cursor: pointer;
        height: 30px;
        width: 30px;
        text-align: center;
        line-height: 30px;
        border-radius: 50%;
        background: #ffffff;
        &:hover {
          opacity: 0.8;
        }
      }
    }
    .marquee-specail {
      border: 4px solid #fff;
    }

    .top,
    .bottom,
    .left,
    .right {
      position: absolute;
      z-index: 100;
      animation: myfirst 0.5s;
      -moz-animation: myfirst 0.5s; /* Firefox */
      -webkit-animation: myfirst 0.5s; /* Safari 和 Chrome */
      -o-animation: myfirst 0.5s;
      animation-fill-mode: forwards;
      -moz-animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      -o-animation-fill-mode: forwards;
    }
    @keyframes myfirst {
      from {
        background: rgba(53, 56, 56, 0);
      }
      to {
        background: rgba(53, 56, 56, 0.77);
      }
    }

    @-moz-keyframes myfirst /* Firefox */ {
      from {
        background: rgba(53, 56, 56, 0);
      }
      to {
        background: rgba(53, 56, 56, 0.77);
      }
    }

    @-webkit-keyframes myfirst /* Safari 和 Chrome */ {
      from {
        background: rgba(53, 56, 56, 0);
      }
      to {
        background: rgba(53, 56, 56, 0.77);
      }
    }

    @-o-keyframes myfirst /* Opera */ {
      from {
        background: rgba(53, 56, 56, 0);
      }
      to {
        background: rgba(53, 56, 56, 0.77);
      }
    }
    .top {
      top: 0px;
      left: 0px;
      width: 100%;
    }
    .bottom {
      left: 0px;
      bottom: 0px;
      width: 100%;
    }
    .left {
      left: 0px;
    }
    .right {
      right: 0px;
    }
  }

  .specail-img {
    width: auto;
    height: 1000px;
    img {
      height: 100%;
      width: auto;
    }
  }
}
</style>
